import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import SharedStoryComponent from 'dyzio-shared-components/lib/components/instagram-story';

import ExistingAds from './existing-ads';

export const STORY_TYPE = 'stories';

const fluidStyle = {
  width: '100%',
};

class InstagramStory extends React.Component {
  constructor() {
    super();
    this.state = {

    };
  }

  render() {
    const { story, ads, unlinkAd } = this.props;
    const storyAttributes = _.get(story, 'attributes');
    const sharedComponentProps = {
      id: _.get(story, 'id'),
      type: _.get(story, 'type'),
      ...storyAttributes,
    };
    return (
      <div style={fluidStyle}>
        <SharedStoryComponent expanded fluid {...sharedComponentProps} handlesCampaignAdd={false} />
        <ExistingAds ads={ads} unlinkAd={unlinkAd} />
      </div>
    );
  }
}

InstagramStory.propTypes = {
  story: PropTypes.object.isRequired,
  ads: PropTypes.array,
  unlinkAd: PropTypes.func,
};

InstagramStory.defaultProps = {
  ads: [],
  unlinkAd: _.noop,
};

export default InstagramStory;




/** WEBPACK FOOTER **
 ** ./src/containers/view-asset-page/instagram-story.js
 **/